(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oldneons-newsletter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oldneons-newsletter')) {
customElements.define('oldneons-newsletter', class extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
const details = this.querySelector('details');
const summary = this.querySelector('summary');
let saved = null;
try { saved = sessionStorage.getItem('oldneons-newsletter-open'); } catch {}
details.open = this.querySelector('[data-newsletter-response]') !== null || (saved === null ? !matchMedia('(max-width:600px)').matches : saved === 'true');
details.addEventListener('toggle', () => {
try { sessionStorage.setItem('oldneons-newsletter-open', String(details.open)); } catch {}
});
const close = () => { details.open = false; summary.focus(); };
this.querySelector('.on-newsletter-close').addEventListener('click', close);
this.addEventListener('keydown', event => {
if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); }
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
